module.exports = __webpack_public_path__ + "1ff4da3296260946dbfa4650ca1dbfa0.pdf";